import type { ActivityCatalogEntry } from '../types'

type Category = ActivityCatalogEntry['category']

export interface CategoryStyle {
  dot: string
  stripe: string
  stripeLocked: string
  activeTab: string
  activeCard: string
  chip: string
}

export const CATEGORY_STYLES: Record<Category, CategoryStyle> = {
  People: {
    dot: 'bg-emerald-500',
    stripe: 'border-l-emerald-500',
    stripeLocked: 'border-l-emerald-200',
    activeTab: 'bg-emerald-100 border-emerald-500 text-emerald-800',
    activeCard: 'border-emerald-300 bg-emerald-50',
    chip: 'bg-emerald-100 text-emerald-800',
  },
  ChangeManagement: {
    dot: 'bg-amber-500',
    stripe: 'border-l-amber-500',
    stripeLocked: 'border-l-amber-200',
    activeTab: 'bg-amber-100 border-amber-500 text-amber-800',
    activeCard: 'border-amber-300 bg-amber-50',
    chip: 'bg-amber-100 text-amber-800',
  },
  Technology: {
    dot: 'bg-cyan-600',
    stripe: 'border-l-cyan-600',
    stripeLocked: 'border-l-cyan-200',
    activeTab: 'bg-cyan-100 border-cyan-500 text-cyan-800',
    activeCard: 'border-cyan-300 bg-cyan-50',
    chip: 'bg-cyan-100 text-cyan-800',
  },
  Innovation: {
    dot: 'bg-rose-500',
    stripe: 'border-l-rose-500',
    stripeLocked: 'border-l-rose-200',
    activeTab: 'bg-rose-100 border-rose-500 text-rose-800',
    activeCard: 'border-rose-300 bg-rose-50',
    chip: 'bg-rose-100 text-rose-800',
  },
  Governance: {
    dot: 'bg-violet-500',
    stripe: 'border-l-violet-500',
    stripeLocked: 'border-l-violet-200',
    activeTab: 'bg-violet-100 border-violet-500 text-violet-800',
    activeCard: 'border-violet-300 bg-violet-50',
    chip: 'bg-violet-100 text-violet-800',
  },
}
